import { useMutation, useQueryClient } from '@tanstack/react-query';

import { companyCrmUsersQuery } from '@/entities/company';
import {
  updateCompanyCrmUserMapping,
  UpdateCompanyCrmUserMappingRequestDto,
} from '@/shared/api/companies';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export function useCompanyCrmUsers(companyId: string | undefined) {
  return useAppQuery({
    ...companyCrmUsersQuery(companyId!),
    enabled: Boolean(companyId),
    customError: true,
  });
}

export function useUpdateCompanyCrmUserMapping(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      crmUserId,
      data,
    }: {
      crmUserId: string;
      data: UpdateCompanyCrmUserMappingRequestDto;
    }) => updateCompanyCrmUserMapping(companyId, crmUserId, data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: companyCrmUsersQuery(companyId).queryKey,
      }),
  });
}
